import { render, staticRenderFns } from "./UserAdressCard.vue?vue&type=template&id=3a0bfb32&scoped=true"
import script from "./UserAdressCard.vue?vue&type=script&lang=js"
export * from "./UserAdressCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0bfb32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a0bfb32')) {
      api.createRecord('3a0bfb32', component.options)
    } else {
      api.reload('3a0bfb32', component.options)
    }
    module.hot.accept("./UserAdressCard.vue?vue&type=template&id=3a0bfb32&scoped=true", function () {
      api.rerender('3a0bfb32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/UserAdressCard.vue"
export default component.exports